const hasIucnIdentifier = (value) => value != null && value !== ''

const hasValidAssessmentId = (assessmentId) => {
  if (!hasIucnIdentifier(assessmentId)) {
    return false
  }

  const numericAssessmentId = Number(assessmentId)

  return !Number.isNaN(numericAssessmentId) && numericAssessmentId > 0
}

export const getIucnRedListSpeciesUrl = (taxonid, assessmentId) => {
  if (!hasIucnIdentifier(taxonid) || !hasValidAssessmentId(assessmentId)) {
    return null
  }

  return `https://www.iucnredlist.org/species/${taxonid}/${assessmentId}`
}

export { hasIucnIdentifier, hasValidAssessmentId }
